{
  "common.close": "閉じる",
  "common.athleteFallback": "アスリート {id}",
  "splash.title": "{app} — アクティビティのアニメーション可視化",
  "splash.tagline": "あなたの Strava&nbsp;データを、動く地図に",
  "splash.demo": "デモ",
  "tab.query.title": "{name} のマップ",
  "tab.query.heading": "アクティビティの検索:",
  "tab.query.optDays": "最近の日数",
  "tab.query.optActivities": "最近のアクティビティ数",
  "tab.query.optIds": "アクティビティ ID",
  "tab.query.optDates": "期間",
  "tab.query.idsPlaceholder": "アクティビティ ID を入力",
  "tab.query.after": "開始:",
  "tab.query.before": "終了:",
  "tab.query.autozoom": "読み込み後、検索範囲に自動ズーム <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> 検索",
  "tab.query.createAccount": "アカウントを作成、またはログインしてください。",
  "tab.query.sports": "スポーツ：",
  "tab.query.allSports": "すべてのスポーツ",
  "tab.query.sportsExcept": "除外：",
  "tab.query.sportsNone": "なし",
  "tab.query.loadingSports": "スポーツを読み込み中…",
  "tab.query.sportsFailed": "このマップのスポーツを読み込めませんでした",
  "tab.query.noSports": "まだアクティビティがありません",
  "tab.activities.title": "表示中のアクティビティ",
  "tab.activities.clearSelection": "選択を解除",
  "tab.activities.renderSelected": "選択を表示",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> 選択範囲にズーム",
  "tab.controls.title": "レイヤー設定",
  "tab.controls.timescale": "時間スケール <i>&tau;</i>",
  "tab.controls.timescaleHint": "再生速度",
  "tab.controls.period": "周期 <i>T</i>",
  "tab.controls.periodHint": "実時間 ~ モデル時間",
  "tab.controls.dotSize": "ドットの大きさ",
  "tab.controls.pathWidth": "軌跡の太さ",
  "tab.controls.pathWidthHint": "0 で軌跡を隠す",
  "tab.controls.colors": "配色",
  "tab.controls.colorsHint": "パレットを回転",
  "tab.controls.shadows": "影",
  "tab.profile.loginTitle": "ログイン",
  "tab.profile.anonNote": "Strava でログインすると、自分のアクティビティを表示し、Heatflask アカウントを管理できます。",
  "tab.profile.loginLink": "Strava でログイン",
  "tab.profile.editOnStrava": "Strava でプロフィールを編集",
  "tab.profile.indexNote": "すばやく表示できるよう、アクティビティの概要を保存しています。",
  "tab.profile.viewIndex": "一覧を表示",
  "tab.profile.sharedMaps": "マップの共有",
  "tab.profile.sharedMapsNote": "オフ：Heatflask であなたのアクティビティを見られるのはあなただけです。オン：マップのリンクを知っている人は、あなたが Strava で公開しているアクティビティを見られます。非公開のアクティビティは、どちらの場合もあなただけのものです。 <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">プライバシーの仕組み</a>",
  "tab.profile.logout": "ログアウト",
  "tab.profile.deleteAccount": "アカウントを削除",
  "tab.profile.deleteConfirm": "Heatflask のアカウントを削除しますか?\n\n保存されたアクティビティは削除され、Heatflask による Strava データへのアクセスも取り消されます。元に戻すことはできません。",
  "tab.profile.languageHeading": "言語",
  "tab.profile.languageAuto": "自動",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">翻訳の修正・追加にご協力ください！</a>",
  "tab.profile.unitsHeading": "単位",
  "tab.profile.unitsAuto": "自動",
  "tab.profile.unitsMetric": "メートル法 (km, m)",
  "tab.profile.unitsImperial": "ヤード・ポンド法 (mi, ft)",
  "tab.profile.textSizeHeading": "文字の大きさ",
  "tab.profile.textSmaller": "小さく",
  "tab.profile.textReset": "標準",
  "tab.profile.textLarger": "大きく",
  "tab.profile.mapDefaultsHeading": "地図の既定値",
  "tab.profile.mapDefaultsNote": "リンクに独自の設定がない地図を開くときは、このベースマップ・地形・レイヤー設定で始めます。共有したリンクには、今見ているとおりの表示がそのまま反映されます。",
  "tab.profile.mapDefaultsSave": "既定値として保存",
  "tab.profile.mapDefaultsForget": "消去",
  "tab.info.title": "情報",
  "tab.info.controlsHeading": "操作",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ドラッグ",
  "tab.info.shiftDragDesc": "範囲を囲んでアクティビティを選択します。タッチ画面では、まず <i class=\"hf-object-group\"></i> をタップしてから一本指でドラッグしてください。最後に選択したアクティビティの詳細が表示され、一覧もそこまでスクロールします。",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ドラッグ",
  "tab.info.ctrlDragDesc": "地図を 3D で回転・傾斜（二本指でも可）",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "サイドバーの開閉",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "前後のタブへ移動",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "サイドバーを閉じる",
  "tab.info.liveUrlHeading": "URL に状態を保存",
  "tab.info.liveUrlDesc": "地図の表示位置とアニメーションの設定は URL に保存されるので、共有した相手にも同じ画面が表示されます。",
  "tab.info.videoHeading": "動画の書き出し",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> ボタンでアニメーションを MP4 として録画できます。ボタンを押し、録画したい範囲を枠で囲み、もう一度押すと録画が始まります。アニメーション一周ぶんを録画するので、繰り返し再生してもつながって見えます。一周が {max} 秒（Strava が受け付ける最大の長さ）を超える場合は {max} 秒で切れます。",
  "tab.info.contributeHeading": "貢献する",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub でスポンサーになる",
  "tab.info.contactsHeading": "連絡先",
  "map.basemapAndTerrain": "ベースマップと地形",
  "map.pauseAnimation": "アニメーションを一時停止",
  "map.resumeAnimation": "アニメーションを再開",
  "capture.record": "動画を録画（一周 {period} 秒）",
  "capture.recordTruncated": "動画を録画（一周 {period} 秒。最初の {max} 秒のみ録画されます）",
  "capture.recordArea": "枠の中を録画",
  "capture.stop": "録画を停止",
  "capture.selectionTooSmall": "選択範囲が小さすぎます",
  "capture.saved": "{name} を保存しました（{size}）",
  "capture.cancelled": "録画を中止しました",
  "capture.failed": "録画に失敗しました: {error}",
  "capture.loadingEncoder": "エンコーダを読み込み中…",
  "capture.waitingForMap": "地図の読み込みを待っています…",
  "capture.encoding": "エンコード中… {percent}%",
  "capture.finalizing": "仕上げ中…",
  "share.title": "このマップへのリンクを共有",
  "share.copied": "リンクをコピーしました",
  "share.copiedUnshared": "リンクをコピーしました。ただしマップが共有されていないため、他の人は開けません。「マップの共有」をオンにすると開けるようになります。",
  "share.unshared": "マップが共有されていないため、他の人はこのリンクを開けません。「マップの共有」をオンにすると開けるようになります。",
  "share.copyThis": "このリンクをコピーしてください:",
  "update.available": "Heatflask の新しいバージョンがあります。",
  "update.reload": "再読み込み",
  "import.title": "読み込み中",
  "import.stop": "停止",
  "import.stopping": "停止しています…",
  "import.contacting": "Strava に接続しています…",
  "import.countOf": "{total} 件中 {received} 件",
  "import.count": "{received} 件",
  "import.waitStrava": "Strava のダウンロード制限のため {time} まで一時停止中です。このまま開いておいてください。再読み込みしても速くなりません。",
  "import.waitRationed": "本日の高速ダウンロード分を使い切りました。残りは {time} から、ゆっくり再開します。このまま開いておいてください。",
  "import.dailyLimit": "Strava の1日のダウンロード上限に達しました。{time} 以降にもう一度お試しください。",
  "import.dailyRationed": "本日の Strava ダウンロードの割り当てを使い切りました。{time} 以降にもう一度お試しください。",
  "import.noActivitiesYet": "Strava アカウントにはまだアクティビティがありません。Strava でアクティビティを記録またはアップロードすると、ここに表示されます。",
  "table.noActivities": "アクティビティなし",
  "table.untitled": "(タイトルなし)",
  "activities.pageTitle": "{app} — アクティビティ索引",
  "activities.heading": "アクティビティ索引",
  "activities.fetching": "アクティビティを取得しています...",
  "activities.rateLimit": "Strava のレート制限に達しました。{time} に再開します",
  "activities.noData": "データがありません &#128577;",
  "activities.colServerCache": "サーバー（Mongo）に保存済みの軌跡",
  "activities.colBrowserCache": "このブラウザに保存済みの軌跡",
  "activities.cachedServer": "{id} の軌跡はサーバーに保存されています",
  "activities.notCachedServer": "{id} の軌跡はサーバーに保存されていません",
  "activities.cachedBrowser": "{id} の軌跡はこのブラウザに保存されています",
  "activities.notCachedBrowser": "{id} の軌跡はこのブラウザに保存されていません",
  "sport.AlpineSki": "アルペンスキー",
  "sport.BackcountrySki": "バックカントリースキー",
  "sport.Badminton": "バドミントン",
  "sport.Basketball": "バスケットボール",
  "sport.Canoeing": "カヌー",
  "sport.Cricket": "クリケット",
  "sport.Crossfit": "クロスフィット",
  "sport.Dance": "ダンス",
  "sport.EBikeRide": "E-バイクライド",
  "sport.Elliptical": "エリプティカル",
  "sport.EMountainBikeRide": "E-マウンテンバイクライド",
  "sport.Golf": "ゴルフ",
  "sport.GravelRide": "グラベルライド",
  "sport.Handcycle": "ハンドサイクル",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "ハイキング",
  "sport.IceSkate": "アイススケート",
  "sport.InlineSkate": "インラインスケート",
  "sport.Kayaking": "カヤック",
  "sport.Kitesurf": "カイトサーフィン",
  "sport.MountainBikeRide": "マウンテンバイクライド",
  "sport.NordicSki": "クロスカントリースキー",
  "sport.Padel": "パデル",
  "sport.PhysicalTherapy": "理学療法",
  "sport.Pickleball": "ピックルボール",
  "sport.Pilates": "ピラティス",
  "sport.Racquetball": "ラケットボール",
  "sport.Ride": "ライド",
  "sport.RockClimbing": "ロッククライミング",
  "sport.RollerSki": "ローラースキー",
  "sport.Rowing": "ローイング",
  "sport.Run": "ラン",
  "sport.Sail": "セーリング",
  "sport.Skateboard": "スケートボード",
  "sport.Snowboard": "スノーボード",
  "sport.Snowshoe": "スノーシュー",
  "sport.Soccer": "サッカー",
  "sport.Squash": "スカッシュ",
  "sport.StairStepper": "ステアステッパー",
  "sport.StandUpPaddling": "スタンドアップパドル",
  "sport.Surfing": "サーフィン",
  "sport.Swim": "スイム",
  "sport.TableTennis": "卓球",
  "sport.Tennis": "テニス",
  "sport.TrailRun": "トレイルラン",
  "sport.Velomobile": "ベロモービル",
  "sport.VirtualRide": "バーチャルライド",
  "sport.VirtualRow": "バーチャルローイング",
  "sport.VirtualRun": "バーチャルラン",
  "sport.Volleyball": "バレーボール",
  "sport.Walk": "ウォーク",
  "sport.WeightTraining": "ウェイトトレーニング",
  "sport.Wheelchair": "車いす",
  "sport.Windsurf": "ウィンドサーフィン",
  "sport.Workout": "ワークアウト",
  "sport.Yoga": "ヨガ"
}
